import { DialogContent, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import React from 'react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { ReactComponent as Graphic24MonthSingle } from './assets/single/chart-24-months.svg';
import { ReactComponent as Graphic36MonthSingle } from './assets/single/chart-36-months.svg';
import { ReactComponent as Graphic48MonthSingle } from './assets/single/chart-48-months.svg';
import { ReactComponent as Graphic60MonthSingle } from './assets/single/chart-60-months.svg';


import { InfoChartSingle } from './InfoChartSingle';

export enum InfoChartTabType {
	SINGLE = 'single',
	MONTHLY = 'monthly',
}

export type InfoChartTerm = 24 | 36 | 48 | 60;

export const useStyles = makeStyles((theme) => ({
	root: {},
	inputBox: {
		backgroundColor: theme.palette.grey[100],
	},
	stretchButton: {
		flex: '1 1 auto',
	},
	tabBar: {
		backgroundColor: theme.palette.grey[100],
		marginBottom: theme.spacing(3),
		boxShadow: '0px 3px 3px 0px rgba(0,0,0,0.2)',
	},
}));

export function getImageSrc(term: number, chartType?: InfoChartTabType) {
	const chartProps = { width: '100%', height: '100%' };

	if (term === 24) {
		return <Graphic24MonthSingle {...chartProps} />;
	}
	if (term === 36) {
		return <Graphic36MonthSingle {...chartProps} />;
	}
	if (term === 48) {
		return <Graphic48MonthSingle {...chartProps} />;
	}
	return <Graphic60MonthSingle {...chartProps} />;
}

export const InfoChart: React.FC<{ showTitle?: boolean }> = ({
	showTitle = true,
}) => {
	const { t } = useTranslation();

	const [term, setTerm] = useState<InfoChartTerm>(24);

	return (
		<div>
			{showTitle && (
				<Typography variant="h2" gutterBottom>
					{t('quickMenu.info.chart.title')}
				</Typography>
			)}

			<DialogContent>
				<InfoChartSingle term={term} setTerm={setTerm} />
			</DialogContent>
		</div>
	);
};
